import { useVerificationContext } from '../../../verification/VerificationContext'
import dayjs from 'dayjs'
import { Bill } from '../bills/Bills'

export const useTestPayAddBillsEligible = () => {
    const { completedAt } = useVerificationContext()

    if (!completedAt) return false

    const daysSinceCompletion = dayjs(dayjs()).diff(completedAt, 'days')

    return daysSinceCompletion < 7
}

export const useTestPayBillEligible = (bill: Bill | null) => {
    const { completedAt: verificationCompletionDate } = useVerificationContext()

    if (!bill) return false

    if (!verificationCompletionDate) return false

    const billCreatedWithin7DaysAfterVerification =
        dayjs(bill.createdAt).diff(verificationCompletionDate, 'days') < 7

    return billCreatedWithin7DaysAfterVerification && bill.testPaymentAvailable
}
